export default __webpack_public_path__ + "static/media/edit-modal.0c5be35c.svg";